/**
 * Browser polyfills for Node.js globals
 * Required for packages like jsonwebtoken that use Node.js built-ins
 */

import { Buffer } from 'buffer';

// Make Buffer available globally for packages like jsonwebtoken
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.Buffer = Buffer;
  // @ts-ignore
  globalThis.Buffer = Buffer;
}

// Ensure process is available (already provided by Vite define, but ensure it's on window too)
if (typeof window !== 'undefined') {
  // @ts-ignore
  if (!window.process) {
    // @ts-ignore
    window.process = { env: {} };
  }
}

